import * as React from 'react'
import { Separator as RadixSeparator } from 'radix-ui'
import { mtc } from '../../../utils/style-helpers'
import { styles } from './styles'

export interface SeparatorProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Set the orientation of the separator to one of: */
  orientation?: 'horizontal' | 'vertical'
}

/** Displays a separator to visually or semantically separate content */
export const Separator: React.FC<
  SeparatorProps & { ref?: React.Ref<HTMLDivElement> }
> = ({ orientation = 'horizontal', className, ref, ...props }) => {
  return (
    <RadixSeparator.Root
      className={mtc(styles({ orientation, className }))}
      orientation={orientation}
      ref={ref}
      {...props}
    />
  )
}

Separator.displayName = 'Separator'
